// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayControllersModelsEnumsAddressContextTypeEnum } from './tCApiGatewayControllersModelsEnumsAddressContextTypeEnum.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsRequestTypesSaveAddressRequestModel {
    'accountId'?: number;
    'contextType'?: TCApiGatewayControllersModelsEnumsAddressContextTypeEnum;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsRequestTypesSaveAddressRequestModel>> = [
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "contextType",
            "baseName": "contextType",
            "type":     "TCApiGatewayControllersModelsEnumsAddressContextTypeEnum"
        },
        {
            "name":     "addressLine1",
            "baseName": "addressLine1",
            "type":     "string"
        },
        {
            "name":     "addressLine2",
            "baseName": "addressLine2",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "zipCode",
            "baseName": "zipCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsRequestTypesSaveAddressRequestModel.attributeTypeMap;
    }
}
